<div
  class="card bg-transparent"
  *ngIf="newsEnabled()">
  <div class="mb-4 flex items-center gap-3">
    <input
      pInputText
      type="text"
      class="w-full md:w-30rem"
      placeholder="Rechercher par titre..."
      [value]="searchText()"
      (input)="onSearchChange($any($event.target).value)"
    />
    <span *ngIf="isSearching()" class="text-600 text-sm">Recherche...</span>
  </div>
  <p-dataView
    [value]="(searchResults() ?? listNews())"
    [paginator]="true"
    [rows]="numberRows()"
    layout="grid"
    class="article-list-dataview"
  >
    <ng-template #grid let-newsList>
      <div class="grid grid-cols-12 gap-4 grid-nogutter bg-transparent mb-8">
        @for (news of newsList; track news.id) {
        <div
          class="col-span-12 sm:col-span-6 lg:col-span-4 p-2 article-card-container"
        >
          <app-news-card [news]="news" [showMotCles]="true"></app-news-card>
        </div>
        }
      </div>
    </ng-template>
    <ng-template #emptymessage>
      <div class="text-center text-700 py-8">Aucun article à afficher.</div>
    </ng-template>
  </p-dataView>
</div>
